var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"mb-2"},[_c('h5',[(_vm.permission.edit)?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"outline-primary","to":{ name: 'FormEdit', params: { id: _vm.item.id, model: 'ugroup' }}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "+_vm._s(_vm.item.name)+" ")],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }